// extracted by mini-css-extract-plugin
module.exports = {"title":"_352tKb-iiG3Ohq8iAmiBXf","text":"_2k7LHFNkVolpj4eqqMw29A","dialogModal":"_3OZZAyB5o6m8JTTbYjIiPA","button":"_3YTHJDaHulmymgDMkzq4Iy","input":"_1j52ZPTuuh_rovrTB_NSkn"};